export const ALMA_TERRITORIES = ['US', 'HK', 'IL', 'CA'];
